// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { ServiceFolderItem_abstract } from './../abstract/SagaSchema/ServiceFolderItem_abstract';
export class ServiceFolderItem extends ServiceFolderItem_abstract {}
